import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { mapLanguageToComponentProps } from 'i18n'
import { ConfirmDelete } from 'components/confirm-delete'
import { Label } from 'components/styled/typography'
import { Average, OwnRating, Rating } from 'components/styled/rating'
import { LoadingIndicator } from 'components/styled/loading-indicator'
import { Flex } from 'components/styled/containers/flex'
import { Box } from 'components/styled/containers/box'

const propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  competency: PropTypes.shape({
    name: PropTypes.string.isRequired,
    _id: PropTypes.string.isRequired,
  }).isRequired,
  onRemove: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onSubmit: PropTypes.func,
  hideReviews: PropTypes.bool,
}

const defaultProps = {
  onRemove: false,
  onSubmit: () => {},
  hideReviews: false,
}

const RatingWrapper = styled.div`
  margin-left: -${({ theme }) => theme.space.s8};

  ${OwnRating} {
    padding-left: ${({ theme }) => theme.space.s8};
  }

  ${Average} {
    font-weight: 400;
  }
`

const LabelContainer = styled(Flex)`
  align-items: center;
  ${({ theme }) => theme.mediaQuery.phone} {
    flex-direction: column;
    align-items: flex-start;
    row-gap: ${({ theme }) => theme.space.s4};
  }
`

const StyledLabel = styled(Label)`
  line-height: ${({ theme }) => theme.space.s24};
`
export class Competency extends Component {
  constructor(props) {
    super(props)
    this.state = {
      confirmDelete: false,
      fetchingCompetency: false,
      fetchingRating: false,
    }

    this.onConfirm = this.onConfirm.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  onConfirm(competency) {
    this.setState({ fetchingCompetency: true })
    this.props.onRemove(competency)
  }

  onSubmit(value) {
    const { onSubmit } = this.props
    this.setState({ fetchingRating: true })
    onSubmit(value).then(() => {
      this.setState({ fetchingRating: false })
    })
  }

  render() {
    const { competency, onRemove, hideReviews, i18n } = this.props
    const { fetchingRating, fetchingCompetency } = this.state

    if (fetchingCompetency) {
      return (
        <Box mt="s16" mb="s16" className="competency">
          <LoadingIndicator centerize={false} size="s20" />
        </Box>
      )
    }

    return (
      <Box mt="s24" mb="s32" className="competency">
        <LabelContainer mt="s16" mb="s8">
          <StyledLabel mb="s0" pr="s8">
            {competency.name}
          </StyledLabel>
        </LabelContainer>
        <RatingWrapper>
          <Rating
            average={competency.rating}
            ownRating={competency.userRating?.value}
            onRate={value => this.onSubmit(value)}
            isLoading={fetchingRating}
            hideReviews={hideReviews}
          />
        </RatingWrapper>
        {onRemove && (
          <Box mt="s8">
            <ConfirmDelete
              item={competency}
              onConfirm={this.onConfirm}
              size="small"
            >
              {i18n.competency.warning}
            </ConfirmDelete>
          </Box>
        )}
      </Box>
    )
  }
}

Competency.propTypes = propTypes
Competency.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps())(Competency)
